import i18n from "i18next";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import frTranslations from "./fr.json";
import enTranslations from "./en.json";
import czTranslations from "./cz.json";
import plTranslations from "./pl.json";
import deTranslations from "./de.json";

async function initI18next() {
  await i18n.use(initReactI18next).init({
    fallbackLng: "fr",
    defaultLng: "fr",
    lng: "fr",
    debug: true,
    react: {
      useSuspense: false,
    },
    resources: {
      fr: {
        translation: frTranslations,
      },
      en: {
        translation: enTranslations,
      },
      cz: {
        translation: czTranslations,
      },
      pl: {
        translation: plTranslations,
      },
      de: {
        translation: deTranslations,
      },
    },
  });
}

initI18next(); // Call the async function to initialize i18next

export const translate = (key) => i18next.t(key);

export const changeLanguage = (lng) => i18next.changeLanguage(lng);
